import { render, staticRenderFns } from "./IEllipsisText.vue?vue&type=template&id=67467f32"
import script from "./IEllipsisText.vue?vue&type=script&lang=js"
export * from "./IEllipsisText.vue?vue&type=script&lang=js"
import style0 from "./IEllipsisText.vue?vue&type=style&index=0&id=67467f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports